<template>
  <h3 class="unit-card-title">{{ text }}</h3>
</template>

<script>
export default {
  name: 'AppCardTitle',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.unit-card-title {
  font-size: 0.875rem;
  font-weight: var(--font-weight-regular);
  line-height: 1.5;
  color: var(--gray-700);
  margin: 0;
}
</style>
